import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./components/ErrorBoundary";
// global styles
import "./styles/global.scss";

const isDebugMode = process.env.REACT_APP_WITH_DEBUG === "true";

const appTree = (
	<Router>
		<App />
	</Router>
);

ReactDOM.render(
	<React.StrictMode>
		{isDebugMode ? <ErrorBoundary>{appTree}</ErrorBoundary> : appTree}
	</React.StrictMode>,
	document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
